export const initiativeTabs = {
  overview: 'overview',
  discussion: 'discussion',
} as const
